import Icon from '@mjcloud/icon';

// 设置平台图标库
Icon.icons = {
  platform: '/font_1269860_i865wp0ldt7/iconfont.js',
};
